// Helpers that keep a stale shipment selection out of the next batch.
//
// The Shipments table keeps its selection across route changes (Vuetify's
// v-data-table remembers selected items by id even when they are no longer
// listed), so after "Close batch" the closed batch's shipments stayed
// selected and "New batch" swept them into the next batch.

/** True when moving between routes should drop the current selection. */
export function batchChanged(to, from) {
  if (!to || !from) return true;
  if (to.name !== from.name) return true;
  const batch = (route) =>
    route.query && route.query.batch != null ? String(route.query.batch) : "";
  return batch(to) !== batch(from);
}

/** A shipment that already has a label/tracking number or has shipped. */
export function isAlreadyShipped(shipment) {
  return Boolean(shipment && (shipment.trackingId || shipment.shippedAt));
}

/**
 * Split a selection the way the API will: shipments already in the target
 * batch are kept; other already-labeled/shipped shipments are skipped.
 */
export function partitionForBatch(selected, targetBatchId = null) {
  const eligible = [];
  const skipped = [];
  (selected || []).forEach((shipment) => {
    const inTarget =
      targetBatchId != null &&
      shipment.batch &&
      String(shipment.batch.id) === String(targetBatchId);
    if (!inTarget && isAlreadyShipped(shipment)) {
      skipped.push(shipment);
    } else {
      eligible.push(shipment);
    }
  });
  return { eligible, skipped };
}

/** Message for the API's meta.skippedShipments, or "" when none. */
export function skippedShipmentsMessage(meta) {
  const skipped = (meta && meta.skippedShipments) || [];
  if (skipped.length === 0) return "";
  const ids = skipped.map((s) => s.id).join(", ");
  return (
    skipped.length +
    (skipped.length === 1 ? " shipment was" : " shipments were") +
    " not added because already labeled/shipped: " +
    ids
  );
}
